'use es6';

export const getTrackingParams = state => state.trackingParams;